module.exports = __webpack_public_path__ + "img/cityulogo.4f5365ff.png";